import { isEmpty } from "lodash"
import * as com from "../Common"

/** Match legacy borrower getLoanAddress display rules for application.property. */
export const getPropertyAddress = (property = {}) => {
    const { address, county, state } = property

    if (isEmpty(address) && isEmpty(county)) {
        return "TBD"
    }

    return isEmpty(address)
        ? `${com.removeCountySuffix(county)}, ${com.convertStateToAbbr(state)}`
        : address
}
